module.exports = __webpack_public_path__ + "static/media/Banner.c67ad249.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/course/Banner.png
// module id = 858
// module chunks = 6